import { render, staticRenderFns } from "./jsaScenario.vue?vue&type=template&id=22523dcc"
import script from "./jsaScenario.vue?vue&type=script&lang=js"
export * from "./jsaScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22523dcc')) {
      api.createRecord('22523dcc', component.options)
    } else {
      api.reload('22523dcc', component.options)
    }
    module.hot.accept("./jsaScenario.vue?vue&type=template&id=22523dcc", function () {
      api.rerender('22523dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/jsaScenario.vue"
export default component.exports